import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {useSelector} from "react-redux";
import {useState} from "react";

const AttributeCard = ({attribute, index, cat}) => {
  const {product, dispatch, errors} = useNewProduct();

  const [attributeState, setAttributeState] = useState(product?.attributes?.find(item => item?.attribute_id == attribute.id) || {});

  const user = useSelector(state => state.user);
  const isAdminType = user?.isAdminType;

  const handleValueSave = (field, value="") => {
    let attributes = product?.attributes?.filter((item) => item?.attribute_id != attribute.id);

    attributes.push({
      attribute_id: attribute.id,
      attribute_value_id: field === 'attribute_value_id' ? value : "",
      attribute_value: field === 'attribute_value' ? value : "",
      position: attributeState.position || '',
    })

    setAttributeState({
      ...attributeState,
      attribute_id: attribute.id,
      [field]: value,
    })

    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {
        ...product,
        attributes: attributes
      }
    })
  }

  const setPosition = (value) => {
    let attributes = product?.attributes?.filter((item) => item?.attribute_id != attribute.id);

    attributes.push({
      ...attributeState, position : value
    })

    setAttributeState({
      ...attributeState,
      position: value,
    })

    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {
        ...product,
        attributes: attributes
      }
    })
  }

  return (
    <div className="card card-flush py-4 mb-10">
      <div className="card-header">
        <div className="card-title">
          <h2>{attribute.name}</h2>
        </div>
      </div>

      <div className="card-body pt-0">
        {
          attribute.values.length > 0 ? (
            <>
              <label className="form-label">Values </label>
              <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                      value={attributeState?.attribute_value_id ?? ''}
                      data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                      onChange={(e) => handleValueSave('attribute_value_id', e.target.value)}
                      disabled={attributeState?.attribute_value}
              >
                <option value="">Select value</option>
                {
                  attribute.values.map((value, index) => (
                    <option key={index}
                            value={value.id}
                    >{value.name}</option>
                  ))
                }
              </select>
              {
                errors[`attribute.${index}.value`] && (
                  <div className="fs-7 mb-7 text-danger">{errors[`attribute.${index}.value`]}</div>
                )
              }
              <div className="text-muted fs-7 mb-7">Select pre-defined value for given attribute</div>
            </>
          ) : ''
        }
        {
          isAdminType && (
            <div className="mb-10 fv-row">
              <label className="form-label">New Value</label>
              <input type="text"
                     key={index}
                     className="form-control mb-2"
                     placeholder="Attribute value"
                     name={`attribute.${index}.value`}
                     value={attributeState?.attribute_value || ""}
                     onChange={(e) => handleValueSave('attribute_value', e.target.value)}
                     disabled={attributeState?.attribute_value_id}
              />
              <div className="text-muted fs-7">
                Create new value for this attribute. If you can't find in predefined values.
                Enter value of your choice!
              </div>
            </div>
          )
        }
        <div className="mb-10 fv-row">
          <label className="form-label">Position</label>
          <input type="number"
                 key={index}
                 className="form-control mb-2"
                 placeholder="Attribute position"
                 name={`attribute.${index}.position`}
                 value={attributeState?.position || ''}
                 onChange={(e) => setPosition(e.target.value)}
                 disabled={!attributeState?.attribute_value_id && !attributeState?.attribute_value}
          />
        </div>
      </div>
    </div>
  )
}

export default AttributeCard;